var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefit"},_vm._l((_vm.benefitContent),function(item){return _c('div',{key:item.id},[_c('p',{staticClass:"question"},[_vm._v(_vm._s(item.question))]),_vm._l((item.answer),function(answer,index){return _c('p',{key:index,staticClass:"answer"},[_vm._v(_vm._s(answer))])})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }